import React, { useState } from "react";
import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import AlertMessage from "../Hooks/AlertMessage";
import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";

export default function AuthTabs() {
   const [activeTab, setActiveTab] = useState("Login");

   const [showAlert, setShowAlert] = useState({ state: false, message: "" });

   const handleTabChange = (event, newValue) => {
      setActiveTab(newValue);
   };

   let time = 3000;

   const handleSignUpSuccess = (response) => {
      setShowAlert({ message: response.message, state: true, type: response.type });

      if (response.type === "success") {
         setActiveTab("Login");
      } else {
         time = 4000;
      }

      // Set the alert to disappear after 3 seconds
      setTimeout(() => {
         setShowAlert({ state: false });
      }, time);
   };

   const handleLoginError = (response) => {
      setShowAlert({ message: response.message, state: true, type: response.type });
      setTimeout(() => {
         setShowAlert({ state: false });
      }, time);
   };
   return (
      <>
         <Helmet>
            <title>{activeTab} | Audley Travel</title>
         </Helmet>
         {showAlert.state && (
            <AlertMessage
               message={showAlert.message}
               type={showAlert.type}
               show={showAlert.state}
               duration={time - 500}
            />
         )}
         <Box
            sx={{
               display: "flex",
               flexDirection: "column",
               justifyContent: "center",
               alignItems: "center",
               minHeight: "100vh", // Ensures the box takes the full viewport height
               px: 2, // Add padding on smaller screens
            }}
         >
            <Typography variant="h4" sx={{ mb: 3, textAlign: "center" }}>
               {activeTab} to Audley Travel
            </Typography>
            <Card
               sx={{
                  p: 4,
                  width: { xs: "100%", sm: "400px" }, // Full width on extra small screens, 400px on small and above
                  boxShadow: 3,
                  borderRadius: 2,
               }}
            >
               <Tabs value={activeTab} onChange={handleTabChange} centered sx={{ marginBottom: 3 }}>
                  <Tab label="Login" value="Login" sx={{ fontSize: 18, fontWeight: "bold" }} />
                  <Tab label="Sign Up" value="SignUp" sx={{ fontSize: 18, fontWeight: "bold" }} />
               </Tabs>

               {activeTab === "Login" && <LoginPage onLogin={handleLoginError} />}
               {activeTab === "SignUp" && <SignupPage onSignUpSuccess={handleSignUpSuccess} />}
            </Card>
         </Box>
      </>
   );
}
